const COOKING_INGREDIENTS = {
  title: 'What goes in',
  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras. Quisque commodo mattis ornare a nec odio. Pulvinar orci, egestas eget nulla duis at iaculis nunc, elit. Nibh auctor purus nunc tellus pellentesque nibh mattis. Malesuada integer consectetur. Imperdiet aliquam quam mauris semper suscipit. Molestie maecenas interdum pharetra id velit sed nec.tetur sit sagittis pretium eget vitae semper pellentesque pellentesque.',
  btn: {
    label: 'Read more',
    href: '#'
  },
  img: {
    src: '/assets/Rectangle34.png',
    alt: 'Cooking ingredients'
  }
};

export default COOKING_INGREDIENTS;
